__turbopack_context__.v({
  "className": "nastaleeqhafs_d9013023-module__s39Rta__className",
});
